<template>
    <div v-if="displayText" class="rankinghint" :class="{ 'rankinghint--compact': compact }">{{ displayText }}</div>
</template>

<script>
import { rankingHintForSeason } from '@/rankingHints';

export default {
    name: 'RankingSeasonHint',
    props: {
        fmpSeasonId: {
            type: [Number, String],
            required: true,
        },
        /** Startseiten-Vorschau: weniger Abstand als unter der Voll-Tabelle, aber etwas Luft zur Tabelle */
        compact: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        displayText() {
            return rankingHintForSeason(this.fmpSeasonId);
        },
    },
};
</script>

<style lang="scss" scoped>
.rankinghint:not(.rankinghint--compact) {
    margin-top: 12px;

    @media (max-width: $breakpoint-sm) {
        margin: 16px 0 -4px;
        padding: 0;
    }
}

.rankinghint--compact {
    margin-top: 8px;

    @media (max-width: $breakpoint-sm) {
        margin: 10px 0 -4px;
        padding: 0;
    }
}
</style>
